import { $, $$, requireElement } from '../../lib/dom';
import { STORAGE_KEYS, writeStorage } from '../../lib/storage';
import {
  estimateCapacity,
  formatNumber,
  INPUT_LIMITS,
  parseBoundedNumber,
  prefillMessage,
  type CapacityInputs,
} from './capacity-estimate';

/** Binds the /calculator form: recalculates on every input and remembers a summary for the demo form. */
export function initCalculator(root: HTMLElement): void {
  const form = $('#calc', root, HTMLFormElement);
  if (!form) return;
  const input = (id: string): HTMLInputElement => requireElement(`#${id}`, root, HTMLInputElement);
  const output = (id: string): HTMLElement => requireElement(`#${id}`, root);

  const recalculate = (): void => {
    const inputs: CapacityInputs = {
      teamSize: parseBoundedNumber(input('c-team').value, INPUT_LIMITS.teamSize),
      minutesPerDay: parseBoundedNumber(input('c-min').value, INPUT_LIMITS.minutesPerDay),
      workingDays: parseBoundedNumber(input('c-days').value, INPUT_LIMITS.workingDays),
      hourlyCost: parseBoundedNumber(input('c-cost').value, INPUT_LIMITS.hourlyCost),
    };
    const estimate = estimateCapacity(inputs);
    output('c-min-out').textContent = `${inputs.minutesPerDay} min`;
    output('r-hours').textContent = formatNumber(Math.round(estimate.hoursPerYear));
    output('r-fte').textContent = formatNumber(estimate.fullTimeEquivalents, 1);
    output('r-pp').textContent = formatNumber(Math.round(estimate.hoursPerPerson));
    output('r-value').textContent = `$${formatNumber(Math.round(estimate.value))}`;
    writeStorage('session', STORAGE_KEYS.calculatorPrefill, prefillMessage(inputs, estimate));
  };

  form.addEventListener('submit', (event) => {
    event.preventDefault();
  });
  $$('input', root).forEach((el) => {
    el.addEventListener('input', recalculate);
  });
  recalculate();
}
